import { isNullOrUndefined } from './null-undefined-helper';

export const formatNumberToDk = (value: number, precision = 0) => value.toLocaleString('da-DK', { minimumFractionDigits: precision, maximumFractionDigits: precision });

export function parseNonNegativeNumber(raw: string): number | undefined {
  if (raw.trim() === '') return undefined;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : undefined;
}

export function formatNumber(value: number, precision = 0): string {
  return isNullOrUndefined(value) ? '' : formatNumberToDk(value, precision);
}

export function formatNullableNumber(value?: number, precision = 0): string {
  return isNullOrUndefined(value) ? '-' : formatNumberToDk(value as number, precision);
}

export const formatAge = (value?: number, missingValue = '') => {
  if (!value) {
    return missingValue;
  }

  if (typeof value === 'number') {
    return `${value} år`;
  }

  return value;
};

export const isStringOnlyNumbers = (value: string): boolean => {
  const regex = /^[0-9]+$/;
  return regex.test(value);
};

/**
 * Formats a number as money with Danish formatting
 * Uses . as thousand separator and , as decimal separator
 * @param value - The number to format
 * @param suffix - Optional suffix to append (e.g., ' kr.')
 * @param precision - Number of decimal places (default: 2)
 * @returns Formatted money string (e.g., '1.234,56 kr.' or '1.234 kr.')
 */
export function formatMoney(value?: number, suffix = ' kr.', precision = 2): string {
  if (isNullOrUndefined(value)) {
    return '';
  }

  const formatted = (value as number).toLocaleString('da-DK', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

  return `${formatted}${suffix}`;
}
